import { Component, OnInit } from '@angular/core';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NeverasService } from '../neveras.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-list-neveras',
  templateUrl: './list-neveras.component.html',
  styleUrls: ['./list-neveras.component.scss'],
})
export class ListNeverasComponent implements OnInit {
  public subscriptions: Subscription[] = [];
  public neveras: any;
  public statusMessage = '';
  public imageBaseURL = '';
  public isLoading = true;
  public currentPage = 1;
  public pageSize = 10;
  public neverasLength = 0;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  constructor(
    private neverasService: NeverasService,
    private router: Router,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) {
    this.fromDate = null;
    this.toDate = null;
    this.resetFilters();

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation?.extras.state as { data: string };
      this.statusMessage = state.data;
    }
    console.log('this.statusMessage: ', this.statusMessage);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.imageBaseURL = environment.imageBaseURL;
  }

  public resetFilters(): void {
    this.fromDate = new NgbDate(2015, 1, 1);
    this.toDate = this.calendar.getToday();
    this.currentPage = 1;
    console.log('this.fromDate: ', this.fromDate);
    console.log('this.toDate: ', this.toDate);
    this.getneverasLength();
  }

  public onPageChange(page: number): void {
    console.log('Changing page to: ', page);
    this.getneveras(page, this.pageSize, this.fromDate, this.toDate);
  }

  public onDateSelection(date: NgbDate, isInterval: boolean): void {
    console.log('date: ', date);
    this.currentPage = 1;
    if (isInterval) {
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (
        this.fromDate &&
        !this.toDate &&
        date &&
        date.after(this.fromDate)
      ) {
        this.toDate = date;
      } else {
        this.toDate = null;
        this.fromDate = date;
      }
    } else {
      this.fromDate = date;
      this.toDate = date;
    }
    this.getneverasLength();
  }

  public isHovered(date: NgbDate): boolean | null {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  public isInside(date: NgbDate): boolean | null {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate): boolean | null {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  private getneverasLength(): void {
    this.subscriptions.push(
      this.neverasService
        .getNeverasLength(
          this.fromDate ? this.formatter.format(this.fromDate) : '2000-01-01',
          this.toDate ? this.formatter.format(this.toDate) : '2099-12-31'
        )
        .subscribe(
          (response) => {
            this.neverasLength =
              response[0] && response[0].length ? response[0].length : 0;
            console.log('neverasLength: ', this.neverasLength);
            this.getneveras(
              this.currentPage,
              this.pageSize,
              this.fromDate,
              this.toDate
            );
            console.log(this.neveras);
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }
  private getneveras(
    currentPage: number,
    pageSize: number,
    fromDate: NgbDate | null,
    toDate: NgbDate | null
  ): void {
    this.subscriptions.push(
      this.neverasService
        .getNeveras(
          currentPage,
          pageSize,
          fromDate ? this.formatter.format(fromDate) : '2000-01-01',
          toDate ? this.formatter.format(toDate) : '2099-12-31'
        )
        .subscribe(
          (response) => {
            this.neveras = response;
            this.isLoading = false;
            console.log(this.neveras);
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }
}
